var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-4" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("tab-nav", {
          staticClass: "col pl-2 pr-2",
          attrs: {
            coloredBackground: "",
            active: _vm.getCurrentType,
            tabs: _vm.availableTypes
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.getCurrentType
      ? _c("div", { staticClass: "row editor-wrapper" }, [
          _c("table", { staticClass: "table col" }, [
            _c("thead", [
              _c(
                "tr",
                [
                  _c("th", [_vm._v(_vm._s(_vm.$t("Editor.key")))]),
                  _vm._v(" "),
                  _vm._l(_vm.availableLanguages, function(i) {
                    return _c("th", {
                      key: i.val,
                      domProps: { innerHTML: _vm._s(i.label) }
                    })
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.groupContent, function(ref) {
                var id = ref[0]
                var value = ref[1]
                return _c(
                  "tr",
                  { key: id },
                  [
                    _c("td", { staticClass: "key" }, [
                      _vm._v(
                        "\n            " + _vm._s(value.key) + "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.availableLanguages, function(ref) {
                      var language = ref.value
                      return _c(
                        "td",
                        { key: language, staticClass: "language-content" },
                        [
                          _c(_vm.getContentEditor, {
                            tag: "component",
                            staticClass: "limit-cell",
                            attrs: {
                              editObject: value.languages[language],
                              contentType: _vm.getCurrentType
                            },
                            on: {
                              updateContent: function($event) {
                                return _vm.updateContent(
                                  $event,
                                  value,
                                  language
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              }),
              0
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57e7e8df", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57e7e8df","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/service/administration/ContentEditor.vue
// module id = null
// module chunks = 